export enum DigestUnsubscribeMode {
  Digest = 'digest',
  Customer = 'customer',
  User = 'user',
}
